import React, {Component} from 'react';
import PropTypes from 'prop-types';

import ItemsListEditor from './items-list-editor';

export default class ItemsListEditorFormElement extends Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,
        incSeedName: PropTypes.string.isRequired,
        addLabel: PropTypes.string,

        colorSelectionEnabled: PropTypes.bool
    };

    static defaultProps = {
        colorSelectionEnabled: false
    }

    UNSAFE_componentWillMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue, newIncSeedValue) => {
        this.props.form.onFormComponentValueChange(this.props.name,newValue);
        if (newIncSeedValue) this.props.form.onFormComponentValueChange(this.props.incSeedName,newIncSeedValue);
    };

    render() {
        const items = this.props.form.getValue(this.props.name);
        const incSeed = this.props.form.getValue(this.props.incSeedName);

        return <ItemsListEditor className={this.props.className}
                                items={items}
                                incSeed={incSeed}
                                colorSelectionEnabled={this.props.colorSelectionEnabled}
                                addLabel={this.props.addLabel}
                                onChange={this.onChange}/>;
    }
}